module.exports = __webpack_public_path__ + "img/error-svgrepo-com.f7ea6e19.svg";